module.exports = __webpack_public_path__ + "img/431.6152fb3c.jpg";